import axios from "@/api/axiosInstance";
import type { GenerateMockTestCompanyResponse } from "./types";

export const generateMockTestCompany =
  async (): Promise<GenerateMockTestCompanyResponse> => {
    const response = await axios.post<GenerateMockTestCompanyResponse>(
      "/api/private/admin/test-companies/mock-data",
    );
    return response.data;
  };
